import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Admins/Add';

const { displayName } = config;

function AddAdmin(): React.JSX.Element {
  document.title = `${displayName}: Добавить администратора`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}

export default AddAdmin;
